// ES6 Modules or TypeScript
import Swal from 'sweetalert2'
import '../scss/swal.scss';

export function confirm(params){
    
    var options = Object.assign({
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie, dziękuję',
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn primary',
            cancelButton: 'btn blue hollow'
        },
    }, params);
    return Swal.fire(options).then(r => r.isConfirmed);
}
export function swalAlert(params){
    
    var options = Object.assign({
        showCloseButton: false,
        // showCancelButton: true,
        // focusConfirm: true,
        confirmButtonText: 'OK',
        // cancelButtonText: 'Nie, dziękuję',
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn primary',
            cancelButton: 'btn blue hollow'
        },
    }, params);
    return Swal.fire(options);
}

window['swalAlert'] = swalAlert;
